/**
 * A failure the frontend raises itself, naming the translation that says it rather than
 * carrying a sentence. Same rule as the API's error codes: whatever throws decides *what*
 * went wrong, and only `useApiError` decides what that sounds like, in which language.
 */
export class LocalizedError extends Error {
  constructor(
    readonly messageKey: string,
    readonly params?: Record<string, unknown>,
  ) {
    // The key doubles as the Error message, for Sentry and for a stack trace.
    super(messageKey);
    this.name = 'LocalizedError';
  }
}
